import { OrderPaypalControllerCompleteMethod } from '../methods/order-paypal-controller/complete.method';

export class OrderPaypalController {
  public readonly complete = new OrderPaypalControllerCompleteMethod();
}
